export default function(sector, fallback = "") {
  switch (sector) {
    case 'communications':
      return 'Communications Ombudsman';
    case 'energy':
      return 'Energy Ombudsman';
    default:
      return fallback
  }
}
